var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMoveBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 72 72"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ic-move-bg_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ic-move-bg_svg__b)",
  d: "M66 36c0 16.569-13.431 30-30 30C19.432 66 6 52.569 6 36 6 19.432 19.432 6 36 6c16.569 0 30 13.432 30 30"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ic-move-bg_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF88BE",
  fillRule: "evenodd",
  d: "M36 65.613c16.355 0 29.613-13.258 29.613-29.613S52.355 6.387 36 6.387 6.387 19.645 6.387 36 19.645 65.613 36 65.613M36 66c16.569 0 30-13.431 30-30C66 19.432 52.569 6 36 6 19.432 6 6 19.432 6 36c0 16.569 13.432 30 30 30",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ic-move-bg_svg__a",
  width: 72,
  height: 72,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_328_4403"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_328_4403",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ic-move-bg_svg__c",
  width: 72,
  height: 72,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_328_4403"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_328_4403",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ic-move-bg_svg__b",
  x1: 12.6,
  x2: 55.2,
  y1: 6,
  y2: 59.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.025,
  stopColor: "#FEC6DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.161,
  stopColor: "#FFD7E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF88BE"
})))));
export default SvgIcMoveBg;